<app-side-menu>
  <div class="cost-centers-content">
    <app-controladoria-nav></app-controladoria-nav>
    <!-- Filtros -->
    <div class="row">
      <div class="col-12">
        <div class="filters-section mb-4">
          <div class="filters-row">
            <div class="filter-group">
              <label for="statusFilter" class="form-label">Status</label>
              <div class="input-group">
                <select id="statusFilter" class="form-select" [(ngModel)]="filters.status" (change)="applyFilters()" [disabled]="loadingStatuses">
                  <option *ngFor="let option of statusOptions" [value]="option.value">{{ option.label }}</option>
                </select>
                <span class="input-group-text" *ngIf="loadingStatuses">
                  <i class="fas fa-spinner fa-spin"></i>
                </span>
              </div>
            </div>

            <div class="filter-actions">
              <button type="button" class="btn btn-outline-secondary" (click)="clearFilters()">
                <i class="fas fa-times me-2"></i>
                Limpar Filtros
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Resumo: Estatísticas Consolidadas (acima da grid) -->
    <div class="row">
      <div class="col-12">
        <div class="cc-stats-strip mb-4">
          <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
            <h5 class="mb-0">
              <i class="fas fa-chart-line me-2 text-primary"></i>
              Estatísticas consolidadas
            </h5>
            <div class="d-flex gap-2">
              <button
                type="button"
                class="btn btn-sm btn-outline-secondary"
                [disabled]="loadingStatisticsSummary"
                (click)="loadStatisticsSummary()">
                <i class="fas fa-sync-alt" [class.fa-spin]="loadingStatisticsSummary"></i>
              </button>
              <button type="button" class="btn btn-sm btn-outline-primary" (click)="openConsolidatedStatisticsReport()">
                <i class="fas fa-external-link-alt me-1"></i>
                Ver relatório completo
              </button>
            </div>
          </div>

          <div *ngIf="loadingStatisticsSummary" class="text-center py-3 text-muted">
            <i class="fas fa-spinner fa-spin me-2"></i>
            Carregando resumo...
          </div>
          <div *ngIf="statisticsSummaryError && !loadingStatisticsSummary" class="alert alert-warning py-2 mb-0 small">
            {{ statisticsSummaryError }}
          </div>
          <div class="row g-3" *ngIf="statisticsSummary && !loadingStatisticsSummary && !statisticsSummaryError">
            <div class="col-6 col-md-3">
              <div class="cc-stats-kpi">
                <span class="cc-stats-kpi-label">Orçamento total</span>
                <span class="cc-stats-kpi-value">{{ statisticsSummary.summary.totalBudget | currency:'BRL' }}</span>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="cc-stats-kpi">
                <span class="cc-stats-kpi-label">Custo total</span>
                <span class="cc-stats-kpi-value">{{ statisticsSummary.summary.totalCost | currency:'BRL' }}</span>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="cc-stats-kpi cc-stats-kpi--danger">
                <span class="cc-stats-kpi-label">Acima do orçamento</span>
                <span class="cc-stats-kpi-value">{{ statisticsSummary.summary.overBudgetCount }}</span>
              </div>
            </div>
            <div class="col-6 col-md-3">
              <div class="cc-stats-kpi cc-stats-kpi--muted">
                <span class="cc-stats-kpi-label">Centros analisados</span>
                <span class="cc-stats-kpi-value">{{ statisticsSummary.totalCostCenters || statisticsSummary.statistics.length }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="cost-centers-card">
<div *ngIf="!costCenters || costCenters.length === 0" class="empty-state">
            <i class="fas fa-chart-pie"></i>
            <h3>Nenhum centro de custo encontrado</h3>
            <p>Cadastre um centro de custo para começar a organizar suas finanças.</p>
            <app-button
              *appHasPermission="'CostCenters.Manage'"
              text="Cadastrar Centro de Custo"
              color="var(--primary-color)"
              (buttonClick)="newCostCenter()"
              className="btn-primary">
              <i class="fas fa-plus me-2"></i>
            </app-button>
          </div>

          <div *ngIf="costCenters && costCenters.length > 0" class="cost-centers-table">
            <div class="table-content">
              <app-table
                [title]="'Centros de Custo'"
                [data]="costCenters"
                [loading]="isLoading"
                [columns]="columns"
                [showSearch]="true"
                [searchPlaceholder]="'Buscar por código ou nome'"
                [clickable]="true"
                [enableSorting]="true"
                [clientSideSort]="true"
                [actions]="actions"
                [searchTerm]="filters.searchTerm"
                [disablePagination]="false"
                [totalItemsFromBackend]="pagination.totalItems"
                [currentPageFromBackend]="pagination.currentPage"
                [totalPagesFromBackend]="pagination.totalPages"
                (rowClick)="view($event)"
                (actionClick)="onActionClick($event)"
                (searchChange)="onSearchChange($event)"
                (pageChange)="onPageChange($event)">
                <div table-header-action class="d-flex gap-2 flex-wrap">
                  <button
                    type="button"
                    class="btn btn-outline-success btn-sm"
                    [disabled]="isExporting || isLoading"
                    (click)="exportToExcel()">
                    <i class="fas fa-file-excel me-1" [class.fa-spin]="isExporting"></i>
                    Exportar Excel
                  </button>
                  <app-button
                    *appHasPermission="'CostCenters.Manage'"
                    text="Novo Centro de Custo"
                    [color]="'var(--primary-light)'"
                    [height]="'42px'"
                    className="new-cost-center-btn"
                    (buttonClick)="newCostCenter()">
                  </app-button>
                </div>
              </app-table>
            </div>

          </div>
        </div>
      </div>
    </div>

    <!-- Modal: Dados Consolidados -->
    <div class="modal fade" 
         [class.show]="showConsolidatedData" 
         [style.display]="showConsolidatedData ? 'block' : 'none'"
         tabindex="-1">
      <div class="modal-dialog modal-lg modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <i class="fas fa-chart-bar me-2"></i>
              Dados Consolidados
            </h5>
            <button type="button" class="btn-close" (click)="closeConsolidatedData()"></button>
          </div>
          <div class="modal-body">
            <div *ngIf="loadingConsolidated" class="text-center py-4">
              <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Carregando...</span>
              </div>
              <p class="mt-3">Carregando dados consolidados...</p>
            </div>

            <div *ngIf="!loadingConsolidated && consolidatedData">
              <!-- Informações Básicas -->
              <div class="consolidated-header mb-4">
                <h4>{{ consolidatedData.costCenter?.code }} - {{ consolidatedData.costCenter?.name }}</h4>
                <p class="text-muted">{{ consolidatedData.costCenter?.description }}</p>
              </div>

              <!-- Cards de Informações -->
              <div class="row g-3">
                <!-- Custo Consolidado -->
                <div class="col-md-6" *ngIf="consolidatedData.cost">
                  <div class="info-card">
                    <div class="info-card-header">
                      <i class="fas fa-dollar-sign"></i>
                      <span>Custo Consolidado</span>
                    </div>
                    <div class="info-card-body">
                      <div class="info-row">
                        <span>Custo Total (+ descendentes):</span>
                        <strong>{{ consolidatedData.cost.consolidatedCost | currency:'BRL' }}</strong>
                      </div>
                      <div class="info-row">
                        <span>Custo Próprio:</span>
                        <span>{{ consolidatedData.cost.actualCost | currency:'BRL' }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Orçamento Consolidado -->
                <div class="col-md-6" *ngIf="consolidatedData.budget">
                  <div class="info-card">
                    <div class="info-card-header">
                      <i class="fas fa-wallet"></i>
                      <span>Orçamento Consolidado</span>
                    </div>
                    <div class="info-card-body">
                      <div class="info-row">
                        <span>Orçamento Total (+ descendentes):</span>
                        <strong>{{ consolidatedData.budget.consolidatedBudget | currency:'BRL' }}</strong>
                      </div>
                      <div class="info-row">
                        <span>Orçamento Mensal:</span>
                        <span>{{ consolidatedData.budget.monthlyBudget | currency:'BRL' }}</span>
                      </div>
                      <div class="info-row">
                        <span>Orçamento Anual:</span>
                        <span>{{ consolidatedData.budget.annualBudget | currency:'BRL' }}</span>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Variação Orçamentária -->
                <div class="col-md-6" *ngIf="consolidatedData.cost && consolidatedData.budget">
                  <div class="info-card">
                    <div class="info-card-header">
                      <i class="fas fa-percent"></i>
                      <span>Análise Orçamentária</span>
                    </div>
                    <div class="info-card-body">
                      <div class="info-row">
                        <span>Variação:</span>
                        <span [class]="calculateVariance(consolidatedData.cost.consolidatedCost, consolidatedData.budget.consolidatedBudget) > 0 ? 'text-danger' : 'text-success'">
                          {{ calculateVariance(consolidatedData.cost.consolidatedCost, consolidatedData.budget.consolidatedBudget) | number:'1.2-2' }}%
                        </span>
                      </div>
                      <div class="info-row">
                        <span>Disponível:</span>
                        <strong [class]="(consolidatedData.budget.consolidatedBudget - consolidatedData.cost.consolidatedCost) >= 0 ? 'text-success' : 'text-danger'">
                          {{ (consolidatedData.budget.consolidatedBudget - consolidatedData.cost.consolidatedCost) | currency:'BRL' }}
                        </strong>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Hierarquia -->
                <div class="col-md-6">
                  <div class="info-card">
                    <div class="info-card-header">
                      <i class="fas fa-sitemap"></i>
                      <span>Hierarquia</span>
                    </div>
                    <div class="info-card-body">
                      <div class="info-row" *ngIf="consolidatedData.level">
                        <span>Nível Hierárquico:</span>
                        <strong>{{ consolidatedData.level.hierarchyLevel }}</strong>
                      </div>
                      <div class="info-row">
                        <span>Total de Descendentes:</span>
                        <strong>{{ consolidatedData.descendants || 0 }}</strong>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="closeConsolidatedData()">Fechar</button>
          </div>
        </div>
      </div>
    </div>

    <!-- Backdrop para modais -->
    <div class="modal-backdrop fade" 
         [class.show]="showConsolidatedData"
         *ngIf="showConsolidatedData"
         (click)="closeConsolidatedData()">
    </div>
  </div>
</app-side-menu>
